export default {
  'menu.MapSelectPage': "地图选择"
}